import { CountriesMockApi } from './countries/api';
import { IconsMockApi } from './icons/api';
import { NavigationMockApi } from './navigation/api';
import { WorkOrdersMockApi } from './work-orders/api';
import { WorkPlansMockApi } from './work-plans/api';
import { WorkDefinitionsMockApi } from './work-definitions/api';

// BomsMockApi deregistered — BOM is fully wired to the real Manufacturing API now (see
// INTEGRATION-GUIDE-BOM-MANUFACTURING-FRONTEND.md). Its wildcard `:scheme//:host/Boms...`
// matcher was intercepting every /Boms/* call client-side before it ever reached the real
// gateway, serving fixture data (BOM-CONVEYOR-BELT, BOM-GEAR-01, ...) from an in-memory array
// that reset on every reload — which is what made BOM screens look mocked. The source file
// (./boms/api.ts, ./boms/data.ts) is left on disk, unregistered, in case local-dev-without-a-
// backend demo mode is wanted again later; it does nothing while absent from this array.
export const mockApiServices = [
    IconsMockApi,
    NavigationMockApi,
    CountriesMockApi,
    WorkOrdersMockApi,
    WorkPlansMockApi,
    WorkDefinitionsMockApi,
];
